<div class="main-container mat-app-background">
  <lfw-navigation-toolbar>
    <ng-container navStart>
      @if (backButtonVisible) {
        <a mat-icon-button class="backbutton" (click)="backButtonClicked()">
          <mat-icon>arrow_back</mat-icon>
        </a>
      }
    </ng-container>
    <ng-container navCenter>
      <div class="doublelined">
        <div class="webdoku showIfEmpty">{{ projectName }}</div>
        <div class="infotext showIfEmpty">{{ infoText }}</div>
      </div>
    </ng-container>
  </lfw-navigation-toolbar>

  <main class="main-outlet-container">
    <ng-content />
  </main>

  @if (isMenuVisible) {
    <div class="footer">
      <ngx-bottom-nav class="bottombar" color="primary">
        @for (mitem of availableItems$ | async; track mitem.id) {
          <button ngx-bottom-nav label="{{ mitem.text }}" [routerLink]="mitem.route" routerLinkActive="active-link">
            <mat-icon ngxBottomNavIcon>{{ mitem.icon }}</mat-icon>
          </button>
        }
        <button ngx-bottom-nav [label]="menuService.cmdUser?.text || ''" (click)="openUserBottomSheet()">
          <mat-icon ngxBottomNavIcon>{{ menuService.cmdUser?.icon }}</mat-icon>
        </button>
      </ngx-bottom-nav>
    </div>
  }
</div>
